import React from 'react';
import { services } from '../mock';
import { Sparkles, Armchair, Shield, Truck, Wrench, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';

const iconMap = {
  Sparkles,
  Armchair,
  Shield,
  Truck,
  Wrench
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-zinc-900 to-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            OUR <span className="bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent">SERVICES</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Professional mobile detailing services brought directly to your location
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group bg-zinc-800/50 border-zinc-700 hover:border-orange-500 overflow-hidden transform hover:scale-105 transition-all duration-500 cursor-pointer"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Service Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 to-transparent opacity-60"></div>
                  
                  {/* Icon Overlay */}
                  <div className="absolute top-4 right-4 bg-orange-500 p-3 rounded-full group-hover:rotate-12 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                </div>

                {/* Service Content */}
                <div className="p-6 space-y-4">
                  <h3 className="text-2xl font-bold text-white group-hover:text-orange-500 transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    {service.description}
                  </p>
                  <Button
                    className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold group-hover:shadow-lg group-hover:shadow-orange-500/50 transition-all duration-300"
                    onClick={() => document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' })}
                  >
                    Get Service
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center space-y-6">
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="lg"
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-8 py-6 text-lg rounded-md transform hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-orange-500/50"
              onClick={() => document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' })}
            >
              View All Packages
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-orange-500 text-white hover:bg-orange-500 hover:text-white font-bold px-8 py-6 text-lg rounded-md transform hover:scale-105 transition-all duration-300"
              onClick={() => window.location.href = 'tel:9162993189'}
            >
              Call (916) 299-3189
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
